{
  "components": {
    "AppNavBar": {
      "cssUrl": "classic",
      "layoutOverlay": true
    },
    "CPFavoritesList": {
      "cssUrl": "classic"
    },
    "CtaWidget": {
      "activeTabOrder": ["lp-tour-day", "lp-interest", "lp-open-day"],
      "auctionRound": {
        "appendIcon": "",
        "dateFormat": "DD/MM/YYYY - HH:mm",
        "prependIcon": "auction_round"
      }
    },
    "PriceChangeIndicator": {
      "priceIndicationIncrease": true,
      "priceIndicationReduction": true,
      "tooltipInfo": false
    },
    "SpFiltersBtnMore": {
      "qDialogProps": {
        "positionDesktop": "standard",
        "positionMobile": "standard",
        "seamless": false
      }
    }
  },
  "customerPanel": {
    "favorites": {
      "resultsCols": {
        "lg": 3,
        "md": 2,
        "sm": 2,
        "xl": 4,
        "xs": 1
      }
    }
  },
  "formats": {
    "currency": {
      "currency": "EUR",
      "delimiter": ".",
      "locale": "en-US",
      "suffix": "€",
      "useGrouping": true
    }
  },
  "icons": {
    "auctionDate": "visits",
    "auctionRound": "auction_round",
    "auctionSibling": "house",
    "collapsedFilter": "filterHorizontal",
    "favorites": "heart",
    "mediaAll": "media",
    "mediaArea": "",
    "mediaDrone": "drone",
    "mediaFloorPlans": "size",
    "mediaPhotos": "media",
    "mediaTour": "tour"
  },
  "listing": {
    "card": {
      "carousel": {
        "desktop": {
          "maxWidth": "300px",
          "minHeight": "220px"
        },
        "map": {
          "maxWidth": "300px",
          "minHeight": "178px"
        },
        "mobile": {
          "maxWidth": "300px",
          "minHeight": "178px"
        }
      }
    }
  },
  "logo": {
    "height": "38px",
    "mobileDrawerHeight": 30,
    "mobileDrawerWidth": 150,
    "smallHeight": "30px",
    "smallWidth": "30px",
    "width": "188px"
  },
  "typography": {
    "fontFamily": "Manrope, -apple-system, BlinkMacSystemFont, 'Segoe UI',  Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    "fontFamilyCdnUrl": "https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap"
  }
}
